/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ApiSortOrderKind {
  Asc = 'asc',
  Desc = 'desc'
}
